import React from "react";
import { Header, Popup, Icon } from "semantic-ui-react";   // add Popup and Icon
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';

import DefinePracticeFlowTree from './../../drive/trees/Practiceflow/PracticeFlowTreePage'

@source({
    mouseEnter: () => {
        dispatch.app.setHelpContext("Playbook Flow Tree")
    }
})
class PracticeFlowTree extends React.Component {

    render() {

        return (
            <div>
                <Header floated='left'>{this.props.name} Flow </Header>
                {this.props.selectedPracticeLibrary.status == 0 ?
                <Popup
                    trigger={<Icon name="info icon blue circle" size="large"/>}
                    content="Right click to add a new phase or a stage"
                    basic
                /> :" "} 
                <DefinePracticeFlowTree
                    className="practiceAcitivty"
                    selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                    user={this.props.user}
                    parent={this.props.selectedPracticeFlowActivity.parentActivity}
                    addAction={dispatch.lifeCycle.createActivity}
                    deleteAction={dispatch.lifeCycle.deleteActivity}
                    updateAction={dispatch.lifeCycle.updateActivity}
                    resourcPane="PracticeFlow"
                    getSelection={dispatch.createPack.getSelectedActivityAsync}
                    setParent={dispatch.createPack.setParentPhaseName}
                    elements="activities"
                    changeIndexAction={dispatch.createPack.changeActivityIndex}
                    selectedPracticeFlowActivity={this.props.selectedPracticeFlowActivity}
                    setUniqueId={this.props.setUniqueId}
                    showResourecePaneFlag={this.props.showResourecePaneFlag}
                    collapsedResourcePaneIndexTemp={this.props.collapsedResourcePaneIndexTemp}
                />
            </div>
        );
    }
}
export default PracticeFlowTree;
